import React from 'react';
import PropTypes from 'prop-types';
import Dialog, { withMobileDialog } from 'material-ui/Dialog';

const PaymentProcessDialog = ({
  fullScreen,
  open,
  handleClose,
  dialogBody,
}) => (
  <Dialog
    fullScreen={fullScreen}
    open={open}
    onClose={handleClose}
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth='md'
    fullWidth
  >
    {dialogBody}
  </Dialog>
);

PaymentProcessDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  dialogBody: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default withMobileDialog({
  breakpoint: 'sm',
})(PaymentProcessDialog);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessDialog.js